import type { FC } from "react";

import { RETIRED_VISAS } from "../../../components/common/visaOptions";
import { VisaTypeSelector } from "../../../components/common/VisaTypeSelector";
import type { CustomCaseType } from "../../customCaseTypes/types";
import {
  NOIR_NOID_WORKFLOW_OPTION,
  RFE_WORKFLOW_OPTION
} from "../../../types/workflow.type";
import { NO_NOTICE_WORKFLOWS } from "../utils";

const UNDERLINE_SELECT_WRAPPER = "max-w-160";

/** Workflows a new case can no longer start on (existing cases keep theirs). */
export const RETIRED_FOR_NEW_CASES: string[] = RETIRED_VISAS;

/** Every workflow, including RFE and NOID/NOIR (plan-locked like everywhere else). */
export const WorkflowStep: FC<{
  customTypes?: readonly CustomCaseType[];
}> = ({ customTypes }) => (
  <div className={UNDERLINE_SELECT_WRAPPER}>
    <VisaTypeSelector
      name="workflow"
      label="Workflow"
      hideLabel
      isRequired
      placeholder="Type or select a workflow..."
      isFullWidth
      excludeVisas={RETIRED_FOR_NEW_CASES}
      variant="unstyled"
      customTypes={customTypes}
    />
  </div>
);

/** The original filing an RFE / NOID-NOIR responds to (prefilled from the notice). */
export const NoticeVisaStep: FC = () => (
  <div className={UNDERLINE_SELECT_WRAPPER}>
    <VisaTypeSelector
      name="noticeVisa"
      label="Base Workflow"
      hideLabel
      isRequired
      placeholder="Type or select the base workflow..."
      isFullWidth
      excludeVisas={[
        RFE_WORKFLOW_OPTION,
        NOIR_NOID_WORKFLOW_OPTION,
        ...RETIRED_FOR_NEW_CASES,
        ...NO_NOTICE_WORKFLOWS
      ]}
      variant="unstyled"
    />
  </div>
);
